import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
    "/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload"
)({
    component: () => (
        <div>Hello /_app/diary/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload!</div>
    ),
});
